import { Organization } from "generated/graphql";
import { OrgPage } from "../state";

export function appendToLastPage(pages: { orgPages: OrgPage[] }, organization: Organization): OrgPage[] {
    if (!organization) {
        return pages.orgPages.slice();
    }
    const copyPages = pages.orgPages.length > 0 ? pages.orgPages.slice() : [{ organizations: [] }];
    const lastPage = copyPages[copyPages.length - 1];

    lastPage.organizations.push(organization);
    return copyPages;
}

function findAllIndexes<T>(list: T[], predicate: (item: T) => boolean): number[] {
    const indices: number[] = [];
    for (let i = 0; i < list.length; ++i) {
        if (predicate(list[i])) {
            indices.push(i);
        }
    }
    return indices;
}

function updateAll(orgs: Organization[], organization: Organization) {
    const indices = findAllIndexes(orgs, o => {
        return o.organizationId === organization.organizationId;
    });
    indices.forEach(index => {
        orgs[index] = organization;
    });
    return indices;
}

export function updateAppInPages(pages: { orgPages: OrgPage[] }, organization: Organization): OrgPage[] {
    const copy = pages.orgPages.slice();
    if (!organization) {
        return copy;
    }
    copy.forEach(p => {
        updateAll(p.organizations, organization);
    });
    return copy;
}
